<div class="app-container">
  <header class="app-header">
    <img src="../assets/logo_blanco.svg" alt="Logo MEDS" class="logo">
  </header>
  <main class="main-content">
    <app-spinner></app-spinner>
    <router-outlet></router-outlet>
  </main>
  <footer></footer>
</div>